import {
  Button,
  Icon,
  Stack,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';

import { InlineEdit } from '../InlineEdit';

interface ChatHeaderProps {
  isLoading: boolean;
  showNewChatButton?: boolean;
  showHistoryButton?: boolean;
  onNewChat: () => void;
  onGoToHistory?: () => void;
  onClose?: () => void;
  threadTitle?: string;
  onThreadTitleChange?: (threadId: string, newTitle: string) => void;
  onThreadTitleEditCancel?: () => void;
  threadId?: string;
}

export const ChatHeader = ({
  isLoading,
  showNewChatButton = true,
  showHistoryButton = false,
  onNewChat,
  onGoToHistory,
  onClose,
  threadTitle,
  onThreadTitleChange,
  onThreadTitleEditCancel,
  threadId,
}: ChatHeaderProps) => {
  return (
    <Stack
      className="border-b border-border-primary px-4 py-4"
      gap={2}
      direction="horizontal"
    >
      <Stack
        gap={3}
        fullWidth={false}
        className="min-w-0 flex-1"
        direction="horizontal"
      >
        {threadId && threadTitle ? (
          <InlineEdit
            className="min-w-0"
            value={threadTitle}
            onSave={(newTitle) =>
              threadId && onThreadTitleChange?.(threadId, newTitle)
            }
            onCancel={onThreadTitleEditCancel}
            isLoading={isLoading}
            placeholder="Thread title"
            maxLength={100}
          >
            <Text
              inline
              weight="medium"
              className="posthog-privacy-text truncate"
            >
              {threadTitle}
            </Text>
          </InlineEdit>
        ) : (
          <Text size="md" weight="medium" color="primary">
            New chat
          </Text>
        )}
      </Stack>
      <Stack gap={1} fullWidth={false} direction="horizontal">
        {showNewChatButton && (
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <Button variant="ghost" onClick={onNewChat} aria-label="New chat">
                <Icon name="SquarePen" size="auto" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>New chat</TooltipContent>
          </Tooltip>
        )}
        {showHistoryButton && (
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                onClick={() => onGoToHistory?.()}
                aria-label="Past chats"
              >
                <Icon name="History" size="auto" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Past chats</TooltipContent>
          </Tooltip>
        )}
        {onClose && (
          <Tooltip delayDuration={0}>
            <TooltipTrigger asChild>
              <Button variant="ghost" onClick={onClose} aria-label="Close">
                <Icon name="X" size="auto" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Close</TooltipContent>
          </Tooltip>
        )}
      </Stack>
    </Stack>
  );
};
